<template>
  <div>
    <section class="user-comment--container">
      <div class="status-container">
        <asc-user-details
          :full-name="'Status Update'"
          :is-user="false"
          :new-comment="false"
          :last-updated="getLastUpdatedTimeStamp"
          :disabled="true"
          :can-edit="false"
          :is-expanded="isExpanded"
          :hide-user-icon="true"
        />
        <!-- <asc-rich-text-input
        class="user-comment--input"
        :can-edit="false"
        :comment="text"
        :new-comment="false"
        :user-list="[]"
        :clear="false"
        :can-post="false"
        :placeholder="''"
        :disabled="true"
        hide-details
        hidden-menu
        allow-images
      /> -->
        <p class="status-text">{{ text }}</p>
      </div>
    </section>
  </div>
</template>

<script>
import variables from '@/styles/_varsJs.scss'
import AscUserDetails from './AscUserDetails'
import AscRichTextInput from '../atoms/AscRichTextInput.vue'

export default {
  name: 'AscUserCommentStatus',

  components: {
    AscUserDetails,
    AscRichTextInput,
  },

  props: {
    statusUpdate: {
      type: Object,
      default: () => {},
    },
    isExpanded: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    text() {
      return this.statusUpdate.message
    },
    getLastUpdatedTimeStamp() {
      return this.statusUpdate.updatedOn
    },
    getFontColor() {
      return variables.gray600
    },
  },
}
</script>

<style lang="scss">
.user-comment {
  &--footer {
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-end;

    .label {
      margin-top: 8px;
      padding: 5px;
    }

    .asc-accent-button-container {
      margin-top: 8px;
    }
  }

  &--container {
    display: flex;
    flex-flow: column nowrap;

    & .user-detail--container > .user-detail--menu {
      opacity: 0;
    }

    &:hover {
      & .user-detail--container > .user-detail--menu {
        opacity: 1;
      }
    }

    .status-container {
      background-color: $gray-0;
      padding: 16px 8px;
      margin-left: 0px;
      position: relative;
      z-index: 1;
      margin-bottom: 11px;
    }

    .status-text {
      color: $gray-600;
      margin-left: 8px;
      margin-top: 8px;
      padding-bottom: 0px;
      margin-bottom: 5px;
    }
  }
}
</style>
